import React from "react";
import bunnyImage from "../../../../public/images/bunny.png";
import { useTranslation } from "react-i18next";
import Button from "../../../common/components/Buttons/Button";
import ConfirmScreen from "../../../common/components/ConfirmScreen/ConfirmScreen";
import ButtonOutlined from "../../../common/components/Buttons/ButtonOutlined";
import AlertMessage from "../../../common/components/AlertMessage";
import styled from "styled-components";
import {
  useResendEmailMutation,
  useSession,
} from "../../../queries/authentication.query";

const StyledConfirmScreen = styled(ConfirmScreen)`
  padding-top: 100px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-top: 32px;
  }
`;

const ErrorWrapper = styled.div`
  min-height: 58px;
  width: auto;
  min-width: 200px;
`;

const VerifyEmail = () => {
  const { t } = useTranslation();
  const { refetch: refreshUserData, isRefetching } = useSession();
  const {
    mutate: resendEmail,
    isLoading: isResending,
    isError,
    isSuccess,
    reset,
  } = useResendEmailMutation();

  return (
    <StyledConfirmScreen
      alertBox={
        <ErrorWrapper>
          <AlertMessage
            isOpen={isError}
            message={t("something-went-wrong")}
            onClose={() => reset()}
          />
        </ErrorWrapper>
      }
      imageSrc={bunnyImage}
      title={`${t("verify-email-title")} \uD83D\uDE1E`}
      description={t("verify-email-desc")}
      actions={
        <>
          <ButtonOutlined
            onClick={() => refreshUserData()}
            text={t("verify-email-refresh")}
            isLoading={isRefetching}
          />
          <Button
            onClick={() => resendEmail()}
            text={t("verify-email-resend")}
            isLoading={isResending}
            disabled={isSuccess}
          />
        </>
      }
    />
  );
};

export default VerifyEmail;
